<template>
  <div class="shrink-0 font-rubik sticky top-[60px] left-0 flex flex-col gap-4">
    <h5 class="text-[1.5rem] leading-[2.125rem]">
      <span v-if="windowWidth > 1024">
        Table of Contents
      </span>
      <button
        v-else
        class="flex items-center justify-between px-4 py-3 w-full text-left text-[1.125rem] leading-[1.6875rem] font-medium bg-white border rounded-md"
        @click="toggleHeadingsButtons"
      >
        <span>Table of Contents</span>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            :d="isHeadingsButtonsOpen
              ? 'M16.293 8.29297L12 12.586L7.70697 8.29297L6.29297 9.70697L12 15.414L17.707 9.70697L16.293 8.29297Z'
              : 'M6.29297 14.2929L7.70697 15.7069L12 11.4139L16.293 15.7069L17.707 14.2929L12 8.58594L6.29297 14.2929Z'
              "
            fill="currentColor"
          />
        </svg>
      </button>
    </h5>
    <ul
      v-show="isHeadingsButtonsOpen"
      class="flex flex-col w-full"
    >
      <li
        v-for="(heading, index) in headings"
        :key="index"
        class="m-0 p-0 w-full"
      >
        <button
          class="py-3 w-full text-left text-[1.125rem] leading-[1.6875rem]"
          :class="[
            {
              'font-medium bg-white border rounded-md': currentHeadingIndex === index
            }
          ]"
          :style="{
            padding: `0 ${heading.level * 1.5}rem`
          }"
          @click="() => scrollToHeading(heading.el.getBoundingClientRect().top)"
        >
          {{ heading.title }}
        </button>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'TableOfContents',
  props: {
    contentContainerId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      headings: [],
      currentHeadingIndex: 0,
      isHeadingsButtonsOpen: true,
      windowWidth: window.innerWidth
    }
  },
  mounted() {
    window.addEventListener('resize', () => this.handleResize())

    const interval = setInterval(() => {
      const contentContainer = document.getElementById(this.contentContainerId)

      if (!contentContainer) {
        return
      }
      
      this.headings = Array.from(
        contentContainer.querySelectorAll('h2, h3, h4, h5, h6') || []
      ).map(heading => ({
        el: heading,
        level: parseInt(heading.tagName[1]),
        title: heading.textContent
      }))

      window.addEventListener('scroll', this.handleScroll)

      clearInterval(interval)
    }, 200)
  },
  beforeDestroy() {
    try {
      window.removeEventListener('resize', this.handleResize)
      window.removeEventListener('scroll', this.handleScroll)
    } catch (e) {
      console.error(e)
    }
  },
  methods: {
    handleResize() {
      this.windowWidth = window.innerWidth
    },
    toggleHeadingsButtons() {
      this.isHeadingsButtonsOpen = !this.isHeadingsButtonsOpen
    },
    handleScroll() {
      const currentHeadingIndex = this.headings.findIndex(heading =>
        heading.el.getBoundingClientRect().top > 0
          && heading.el.getBoundingClientRect().top < window.innerHeight
      )
      if (currentHeadingIndex !== this.currentHeadingIndex) {
        this.currentHeadingIndex = currentHeadingIndex
      }
    },
    scrollToHeading(top) {
      window.scrollTo({ top: top + window.scrollY - 60, behavior: 'smooth' })
    }
  }
}
</script>